import { inject, observer } from "mobx-react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Button, Input, Checkbox } from "antd";
import { FormComponentProps } from "@ant-design/compatible/lib/form";
import React from "react";

import AuthStore from "app/AuthStore";
import PageStore from "app/PageStore";
import { setCookie, getCookie } from "lib/cookie";

interface LoginFormProps extends FormComponentProps {
  authStore?: AuthStore;
  pageStore?: PageStore;
}

@inject("authStore", "pageStore")
@observer
class LoginForm extends React.Component<LoginFormProps> {
  public render() {
    const { getFieldDecorator } = this.props.form;
    const username = getCookie("username");
    const password = getCookie("password");
    return (
      <Form onSubmit={this.handleOnSubmit} className="login-form">
        <Form.Item>
          {getFieldDecorator("username", {
            rules: [{ required: true, message: "Please input your Username!" }],
            initialValue: username,
          })(
            <Input
              prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="Username"
            />,
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator("password", {
            rules: [{ required: true, message: "Please input your Password!" }],
            initialValue: password,
          })(
            <Input
              prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
              type="password"
              placeholder="Password"
            />,
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator("remember", {
            valuePropName: "checked",
            initialValue: true,
          })(<Checkbox>Remember me</Checkbox>)}
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            block
          >
            Log in
          </Button>
        </Form.Item>
      </Form>
    );
  }

  private handleOnSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    this.props.pageStore!.openSpinner();
    this.props.form.validateFields((err, values) => {
      this.props.pageStore!.closeSpinner();
      if (!err) {
        this.props.authStore!.login(values);
        if (values.remember) {
          setCookie("username", values.username);
          setCookie("password", values.password);
        }
      }
    });
  };
}

const WrappedLoginForm = Form.create()(LoginForm);
export default WrappedLoginForm;
